import React, { useState, useEffect } from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

const Loader = () => {
  const [playing, setPlaying] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setPlaying(false); 
    }, 40000); 

    return () => clearTimeout(timer); 
  }, []);

  return (
    <div className="flex justify-center items-center h-screen w-screen bg-gradient-to-r from-white to-success/40">
      <DotLottieReact
        src="https://lottie.host/68fb123d-6d62-4a34-847f-6f1987594b9a/X5hcaVRuJY.lottie"
        loop={false} 
        autoplay={true} 
        speed={2.5} 
        className="w-24 h-24"
        style={{ visibility: playing ? 'visible' : 'hidden' }} 
      />
    </div>
  );
};

export default Loader;
